import React, {useState, createContext, useContext} from 'react';

export interface LeftSidebarDataType {
    displayedElementInactif: boolean,
    setDisplayedElementInactif: React.Dispatch<React.SetStateAction<boolean>>,
}

//create context
export const LeftSidebarDataContext = createContext<LeftSidebarDataType>({
    displayedElementInactif: false
} as LeftSidebarDataType);

//context provider 
export const LeftSidebarDataContextProvider = (props: React.PropsWithChildren) => {
    const [displayedElementInactif, setDisplayedElementInactif] = useState<boolean>(false) ;

    const contextData : LeftSidebarDataType ={
        displayedElementInactif,
        setDisplayedElementInactif
    }

    return(
        <LeftSidebarDataContext.Provider value={contextData}>
          {props.children}  
        </LeftSidebarDataContext.Provider>
    )
}

export const useContextLeftSidebarData = () => useContext(LeftSidebarDataContext)
